

import {Card, TextField } from '@mui/material'
import HeaderGestorConfigs from '../../../../../utils/headerGestorConfigs'
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import api from '../../../../../services/api';
import MessageSuccess from '../../../../../messages/messageSuccess';
import MessageError from '../../../../../messages/messageError';
import ButtonLeft from '../../../../../utils/buttonLeft';

export default function AddTeorBaseProducto({ setProduto, produto }) {
    const user = useSelector(state => state.account.user);
    const dispatch = useDispatch()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const [teorBase, setTeorBase] = useState('')


    const handleTeorBase = () => {
        setLoad(true)
        api.patch('/producto/edit-teor-base', {
            // status: status,
            productoId: produto._id,
            teorBase,
            userId: user?._id
        }).then(response => {
            setProduto(response.data.producto)
            dispatch({
                type: 'alert',
                payload: { alert: 'Teor Base atribuida com sucesso.!' },
            });
            // console.log(response)
        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    return (

        <Card style={{ padding: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'ATRIBUIÇÃO DE TEOR BASE'}
            />

            <br />
            <TextField
                type='number'
                size="small"
                fullWidth
                label="Atribuir teorBase"
                defaultValue={produto?.teorBaseG}
                onChange={(e) => setTeorBase(e.target.value)}
                variant="outlined" />

            <ButtonLeft funcao={handleTeorBase}  title={'salvar'} disabled={load || !teorBase} load={load}/>
        </Card>

    )
}
